import * as createjs from 'createjs-module';

export class CjShadow extends createjs.Shadow {
  constructor(color: string, offsetX: number, offsetY: number, blur: number) {
    super(color, offsetX, offsetY, blur);
  }
}